import React from 'react';
import { Link } from 'react-router-dom';

const SignUpToSubmit: React.FC = () => {
    return (
        <div className="container mx-auto px-4 py-8 text-center">
            <h1 className="text-2xl font-bold mb-4">Want to add your event?</h1>
            <p className="mb-6">Please sign up or log in to submit your events.</p>
            <Link 
                to="/auth" 
                className="bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600 transition-colors"
            >
                Sign Up / Login
            </Link>
        </div>
    );
};

export default SignUpToSubmit; 